import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgDropIconSecondary from './svgs/DropIconSecondary.js';
import SvgDropIcon from './svgs/DropIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var dropIcon = (props => useIcon(SvgDropIcon, SvgDropIconSecondary, props));

export { dropIcon as default };
